module.exports = __webpack_public_path__ + "static/media/YF76_03.124ec8d2.jpg";